import { standardRubricFragment } from "AppComponents/StandardRubric/modules/StandardRubricFragments";
import { checklistFragment } from "Checklist/modules/ChecklistFragments";
import { gql } from "lib/apolloClient";
import { rubricFragment } from "Rubric/modules/RubricFragments";
import { singlePointRubricFragment } from "SinglePointRubric/modules/SinglePointRubricFragments";

export const getLearningCourseAssessmentToolsQuery = gql`
  query getLearningCourseAssessmentTools(
    $id: ID!
    $filters: AssessmentToolFilters
  ) {
    node(id: $id, type: LEARNING_COURSE) {
      id
      ... on LearningCourse {
        assessmentTools(filters: $filters) {
          totalCount
          edges {
            node {
              id
              assessmentToolType
              lockingInfo {
                isLocked
              }
              assessmentToolItem {
                id
                ... on Rubric {
                  ...rubricItem
                }
                ... on Checklist {
                  ...checklist
                }
                ... on SinglePointRubric {
                  ...singlePointRubricItem
                }
                ... on StandardRubric {
                  ...standardRubricItem
                }
              }
            }
          }
        }
      }
    }
  }
  ${rubricFragment.rubric}
  ${checklistFragment.checklist}
  ${singlePointRubricFragment.singlePointRubric}
  ${standardRubricFragment.standardRubric}
`;

export const getAssessmentToolsLockingStatusQuery = gql`
  query getAssessmentToolsLockingStatus($id: ID!) {
    node(id: $id, type: LEARNING_COURSE) {
      id
      ... on LearningCourse {
        id
        lockingInfo {
          pageTypes
        }
      }
    }
  }
`;
